import { Edit, Save } from '@mui/icons-material';
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { ICourtCourtRole } from '../../../Interfaces/IAemter';
import { IDocument } from '../../../Interfaces/IDocument';
import {
  ILegalRequirement,
  ILegalRequirementFullObject,
} from '../../../Interfaces/ILegalRequirement';
import { ILegalRequirementDeadline } from '../../../Interfaces/ILegalRequirement_deadlines';
import { TextModuleSelector } from '../../../TextModule/TextModuleSelector';
import { CustomEditor } from '../../../core/CustomEditor';
import { AddPrerequisiteDeadline } from './AddPrerequisiteDeadline';
import { LegalRequirementAddCourt } from './LegalRequirementAddCourt';
import { LegalRequirementDeadlineTable } from './LegalRequirementDeadlineTable';
import { DocumentOverview } from '../../../Document/DocumentOverview';

interface IProps {
  currentRequirement: ILegalRequirementFullObject;
  setCurrentRequirement: Function;
  courtcourtroleArray: ICourtCourtRole[];
  legaltransactionId: number;
}

export const EditLegalRequirementData: React.FC<IProps> = ({
  currentRequirement,
  setCurrentRequirement,
  courtcourtroleArray,
  legaltransactionId,
}) => {
  // useStates
  const isSendEmailPossible =
    currentRequirement.sendMail === true ||
    currentRequirement.isInterneLegalRequirement === true;

  const [currentEmployeesDocumentArray, setCurrentEmployeesDocumentArray] =
    useState<IDocument[]>([]);

  useEffect(() => {
    const updatedArray = currentRequirement.DocumentArrayEmployees
      ? currentRequirement.DocumentArrayEmployees.map(doc => ({
          ...doc,
          perEmail: isSendEmailPossible ? doc.perEmail : false,
        }))
      : [];

    setCurrentEmployeesDocumentArray(updatedArray);
  }, [isSendEmailPossible]);

  const [editactualProcessingTime, setEditActualProcessingTime] =
    useState(false);
  const [courtcourtroleDialogOpen, setCourtcourtroleDialogOpen] =
    useState(false);
  const [addPrerequisteDeadlineOpen, setAddPrerequisteDeadlineOpen] =
    useState(false);
  const [editInitialProcessingTime, setEditInitialProcessingTime] =
    useState(false);
  const getCourtCourtRoleCurrentProcessingTime = useCallback(
    (idCourt: number, idCourtRole: number) => {
      if (courtcourtroleArray === undefined) return null;
      const courtCourtRole = courtcourtroleArray.find(
        x => x.idCourt === idCourt && x.idCourtRole === idCourtRole
      );
      return courtCourtRole?.currentProcessingTime
        ? courtCourtRole.currentProcessingTime
        : courtCourtRole?.initalProcessingTime;
    },
    [courtcourtroleArray]
  );
  //
  const handleChangePrerequisteDeadline = useCallback(
    (changedPrequiste: ILegalRequirementDeadline) => {
      const newArray = currentRequirement.DeadlineArray
        ? currentRequirement.DeadlineArray
        : [];

      if (changedPrequiste.idDeadline === -1) {
        changedPrequiste.idDeadline = Math.floor(Math.random() * 1000000);
        newArray.push(changedPrequiste);
      } else {
        const index = newArray.findIndex(
          x => x.idDeadline === changedPrequiste.idDeadline
        );
        if (index === -1) {
          newArray.push(changedPrequiste);
        } else {
          newArray[index] = changedPrequiste;
        }
      }
      setCurrentRequirement({
        ...currentRequirement,
        DeadlineArray: newArray,
      });
    },
    [
      currentRequirement,
      setCurrentRequirement,
      courtcourtroleArray,
      legaltransactionId,
    ]
  );

  const handleDeleteDeadline = useCallback(
    (index: number) => {
      const newArray = currentRequirement.DeadlineArray
        ? currentRequirement.DeadlineArray
        : [];
      newArray.splice(index, 1);
      setCurrentRequirement({
        ...currentRequirement,
        DeadlineArray: newArray,
      });
    },
    [
      currentRequirement,
      setCurrentRequirement,
      courtcourtroleArray,
      legaltransactionId,
    ]
  );
  // useEffects
  useEffect(() => {
    setCurrentRequirement({
      ...currentRequirement,
      DocumentArrayEmployees: currentEmployeesDocumentArray,
    });
  }, [currentEmployeesDocumentArray]);

  return (
    <Box sx={{ m: 2 }}>
      <Grid container spacing={2}>
        <Grid item sm={2}>
          <TextField
            label='interne Maßnahme'
            value={
              currentRequirement.isInterneLegalRequirement === true
                ? 'true'
                : 'false'
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentRequirement({
                ...currentRequirement,
                isInterneLegalRequirement: event.target.value === 'true',
                sendMail:
                  event.target.value === 'true'
                    ? false
                    : currentRequirement.sendMail,
              })
            }
            size='small'
            fullWidth
            select
          >
            <MenuItem value='true'>Ja</MenuItem>
            <MenuItem value='false'>Nein</MenuItem>{' '}
          </TextField>
        </Grid>
        <Grid item sm={10}>
          <TextField
            label='Bedingung'
            value={currentRequirement.LegalRequirement}
            error={currentRequirement.LegalRequirement === ''}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentRequirement({
                ...currentRequirement,
                LegalRequirement: event.target.value,
              })
            }
            size='small'
            fullWidth
          />
        </Grid>

        <Grid item sm={6}>
          <TextField
            label='Mitarbeiter kann Dateien hochladen'
            value={
              currentRequirement.canUploadFilesEmployees === true
                ? 'true'
                : 'false'
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setCurrentRequirement({
                ...currentRequirement,
                canUploadFilesEmployees: event.target.value === 'true',
                DocumentArray:
                  event.target.value === 'false'
                    ? []
                    : currentRequirement.DocumentArrayEmployees,
              });
              setCurrentEmployeesDocumentArray(
                event.target.value === 'false'
                  ? []
                  : currentEmployeesDocumentArray
              );
            }}
            size='small'
            fullWidth
            select
          >
            <MenuItem value='true'>Ja</MenuItem>
            <MenuItem value='false'>Nein</MenuItem>
          </TextField>
        </Grid>
        <Grid item sm={6}>
          <TextField
            label='Mandant kann Dateien hochladen'
            value={
              currentRequirement.canUploadFilesClient === true
                ? 'true'
                : 'false'
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentRequirement({
                ...currentRequirement,
                canUploadFilesClient: event.target.value === 'true',
              })
            }
            size='small'
            fullWidth
            select
          >
            <MenuItem value='true'>Ja</MenuItem>
            <MenuItem value='false'>Nein</MenuItem>
          </TextField>
        </Grid>

        {currentRequirement.canUploadFilesEmployees === true && (
          <Grid mt={6} item sm={12}>
            <DocumentOverview
              key={`DocumentOverview-employees`}
              documentArray={currentEmployeesDocumentArray}
              setDocumentArray={setCurrentEmployeesDocumentArray}
              allowRemove={true}
              allowUpload={true}
              title='Für den Mandanten bereitgestellte Daten'
              isStandarddocument={true}
              isSendEmailPossible={isSendEmailPossible}
            />
          </Grid>
        )}

        <Grid item sm={12}>
          <Box
            component='fieldset'
            sx={{
              borderColor: '#ccc',
              border: 1,
              borderRadius: 4,
              padding: 2,
              marginTop: 4,
              position: 'relative',
            }}
          >
            <Typography
              component='legend'
              sx={{ fontSize: '0.875rem', padding: '0 8px' }}
            >
              Fristen und Gerichte
            </Typography>
            <Grid container spacing={2} justifyContent='center'>
              {(currentRequirement.idCourt === null ||
                currentRequirement.idCourt === undefined) &&
                (currentRequirement.idCourtRole === null ||
                  currentRequirement.idCourtRole === undefined) && (
                  <>
                    <Grid
                      item
                      xs={12}
                      display={'flex'}
                      alignItems={'center'}
                      justifyContent={'space-between'}
                    >
                      {editInitialProcessingTime ? (
                        <>
                          <Tooltip title='Die geschätzte Bearbeitungszeit ist die geschätzte Zeit für den Abschluss dieser Maßnahme unter normalen Umständen. Diese Zeit wird täglich automatisch basierend auf den historischen Werten angepasst. Sollten Sie den Wert verändern, wird die automatische Anpassung deaktiviert.'>
                            <TextField
                              label='Geschätzte Bearbeitungszeit'
                              type='number'
                              value={
                                currentRequirement.initialProcessingTime
                                  ? currentRequirement.initialProcessingTime
                                  : ''
                              }
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) =>
                                setCurrentRequirement({
                                  ...currentRequirement,
                                  initialProcessingTime: Number(
                                    event.target.value
                                  ),
                                  ManualProcessingTime: true,
                                } as ILegalRequirementFullObject)
                              }
                              size='small'
                              sx={{ width: '50%' }}
                            />
                          </Tooltip>
                          <Tooltip title='Bearbeiten beenden'>
                            <IconButton
                              onClick={() => {
                                setEditInitialProcessingTime(false);
                              }}
                            >
                              <Save />
                            </IconButton>
                          </Tooltip>
                        </>
                      ) : (
                        <>
                          <Tooltip title='Die geschätzte Bearbeitungszeit ist die geschätzte Zeit für den Abschluss dieser Maßnahme unter normalen Umständen. Diese Zeit wird täglich automatisch basierend auf den historischen Werten angepasst. Sollten Sie den Wert verändern, wird die automatische Anpassung deaktiviert.'>
                            <Typography
                              variant='body1'
                              style={{ whiteSpace: 'nowrap' }}
                            >
                              Geschätzte Bearbeitungszeit:{' '}
                              {currentRequirement.initialProcessingTime !==
                              null ? (
                                <>
                                  {currentRequirement.initialProcessingTime}{' '}
                                  Tage
                                </>
                              ) : (
                                'noch nicht festgelegt'
                              )}
                            </Typography>
                          </Tooltip>
                          <Tooltip title='Aktivieren Sie die Funktion, wenn Sie nicht wünschen, dass die geschätze Bearbeitungszeit automatisch angepasst wird.'>
                            <Box display='flex' alignItems={'center'}>
                              <Typography
                                variant='body1'
                                style={{ whiteSpace: 'nowrap' }}
                              >
                                Automatische Anpassung deaktiviert
                              </Typography>
                              <Checkbox
                                checked={
                                  currentRequirement.ManualProcessingTime
                                }
                                onChange={(
                                  event: React.ChangeEvent<HTMLInputElement>
                                ) =>
                                  setCurrentRequirement({
                                    ...currentRequirement,
                                    ManualProcessingTime: event.target.checked,
                                  })
                                }
                              />
                            </Box>
                          </Tooltip>
                          <Tooltip title='Setzen Sie die geschätze benötigte Zeit manuell'>
                            <IconButton
                              onClick={() => {
                                setEditInitialProcessingTime(true);
                              }}
                            >
                              <Edit />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      display={'flex'}
                      alignItems={'center'}
                      justifyContent={'space-between'}
                    >
                      {editactualProcessingTime ? (
                        <>
                          <TextField
                            label='Tatsächliche Bearbeitungszeit'
                            type='number'
                            value={currentRequirement.actualProcessingTime}
                            onChange={(
                              event: React.ChangeEvent<HTMLInputElement>
                            ) =>
                              setCurrentRequirement({
                                ...currentRequirement,
                                actualProcessingTime: Number(
                                  event.target.value
                                ),
                              })
                            }
                            size='small'
                          />
                          <Tooltip title='Bearbeiten beenden'>
                            <IconButton
                              onClick={() => {
                                setEditActualProcessingTime(false);
                              }}
                            >
                              <Save />
                            </IconButton>
                          </Tooltip>
                        </>
                      ) : (
                        <>
                          <Tooltip title='Die tatsächlich benötigte Zeit'>
                            <Typography
                              variant='body1'
                              style={{ whiteSpace: 'nowrap' }}
                            >
                              Tatsächliche Bearbeitungszeit:{' '}
                              {currentRequirement.actualProcessingTime !==
                                null &&
                              currentRequirement.actualProcessingTime !==
                                undefined ? (
                                <>
                                  {currentRequirement.actualProcessingTime} Tage
                                </>
                              ) : (
                                'Die Maßnahme befindet sich noch in Bearbeitung'
                              )}
                            </Typography>
                          </Tooltip>
                          <Tooltip title='Bearbeiten Sie die tatsächlich benötigte Zeit'>
                            <IconButton
                              onClick={() => {
                                setEditActualProcessingTime(true);
                              }}
                            >
                              <Edit />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      display='flex'
                      alignItems='center'
                      justifyContent='space-between'
                    ></Grid>
                    <Tooltip title='Alternativ können Sie auch ein zuständiges Amt für diese Maßnahme festlegen. Die Bearbeitungszeit wird dann automatisch basierend auf den Daten des zuständigen Amts kaluliert.'>
                      <Button
                        variant='contained'
                        color='primary'
                        sx={{ mt: 1 }}
                        onClick={() => {
                          setCourtcourtroleDialogOpen(true);
                        }}
                      >
                        Zuständiges Amt festlegen
                      </Button>
                    </Tooltip>
                  </>
                )}
              <Grid item xs={12}>
                <Box>
                  {currentRequirement.idCourt &&
                    currentRequirement.idCourt !== null &&
                    currentRequirement.idCourtRole &&
                    currentRequirement.idCourtRole !== null && (
                      <>
                        <Grid
                          item
                          xs={12}
                          display={'flex'}
                          alignItems={'center'}
                          justifyContent={'space-between'}
                        >
                          <Tooltip title='Das Amt, welches für die Bearbeitung dieser Maßnahme zuständig ist.'>
                            <Typography variant='body1'>
                              Amt: {currentRequirement.CourtRole}{' '}
                              {currentRequirement.Court}
                            </Typography>
                          </Tooltip>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          display={'flex'}
                          alignItems={'center'}
                          justifyContent={'space-between'}
                        >
                          <Tooltip title='Die geschätzte Bearbeitungszeit des zuständigen Amts'>
                            <Typography
                              variant='body1'
                              style={{ whiteSpace: 'nowrap' }}
                            >
                              Geschätzte Bearbeitungszeit:{' '}
                              {getCourtCourtRoleCurrentProcessingTime(
                                currentRequirement.idCourt,
                                currentRequirement.idCourtRole
                              ) !== null ? (
                                <>
                                  {getCourtCourtRoleCurrentProcessingTime(
                                    currentRequirement.idCourt,
                                    currentRequirement.idCourtRole
                                  )}{' '}
                                  Tage
                                </>
                              ) : (
                                'noch nicht festgelegt'
                              )}
                            </Typography>
                          </Tooltip>
                          <Box display={'flex'} alignItems={'center'}>
                            {editactualProcessingTime ? (
                              <>
                                <TextField
                                  label='Tatsächliche Bearbeitungszeit'
                                  type='number'
                                  value={
                                    currentRequirement.actualProcessingTime
                                  }
                                  onChange={(
                                    event: React.ChangeEvent<HTMLInputElement>
                                  ) =>
                                    setCurrentRequirement({
                                      ...currentRequirement,
                                      actualProcessingTime: Number(
                                        event.target.value
                                      ),
                                    })
                                  }
                                  size='small'
                                />
                                <Tooltip title='Bearbeiten beenden'>
                                  <IconButton
                                    onClick={() => {
                                      setEditActualProcessingTime(false);
                                    }}
                                  >
                                    <Save />
                                  </IconButton>
                                </Tooltip>
                              </>
                            ) : (
                              <>
                                <Tooltip title='Die tatsächlich benötigte Zeit'>
                                  <Typography
                                    ml={2}
                                    variant='body1'
                                    style={{ whiteSpace: 'nowrap' }}
                                  >
                                    Tatsächliche Bearbeitungszeit:{' '}
                                    {currentRequirement.actualProcessingTime !==
                                      null &&
                                    currentRequirement.actualProcessingTime !==
                                      undefined ? (
                                      <>
                                        {
                                          currentRequirement.actualProcessingTime
                                        }{' '}
                                        Tage
                                      </>
                                    ) : (
                                      'Die Maßnahme befindet sich noch in Bearbeitung'
                                    )}
                                  </Typography>
                                </Tooltip>
                                <Tooltip title='Bearbeiten Sie die tatsächlich benötigte Zeit'>
                                  <IconButton
                                    onClick={() => {
                                      setEditActualProcessingTime(true);
                                    }}
                                  >
                                    <Edit />
                                  </IconButton>
                                </Tooltip>
                              </>
                            )}
                          </Box>
                        </Grid>

                        <Box display='flex' gap={2}>
                          <Tooltip title='Ändern Sie die Zuweisung zu einem anderen Amt'>
                            <Button
                              variant='contained'
                              color='primary'
                              sx={{ mt: 1 }}
                              onClick={() => {
                                setCourtcourtroleDialogOpen(true);
                              }}
                            >
                              Zuweisung ändern
                            </Button>
                          </Tooltip>
                          <Tooltip title='Alternativ können Sie auch die Zuweisung zu einem Amt löschen. Die Bearbeitungszeit wird dann basierend auf historischen Daten der Maßnahme berechnet.'>
                            <Button
                              variant='contained'
                              color='warning'
                              sx={{ mt: 1 }}
                              onClick={() => {
                                setCurrentRequirement({
                                  ...currentRequirement,
                                  idCourt: null,
                                  idCourtRole: null,
                                  Court: null,
                                  CourtRole: null,
                                });
                              }}
                            >
                              Zuweisung löschen
                            </Button>
                          </Tooltip>
                        </Box>
                      </>
                    )}

                  <Divider>
                    <Typography variant='subtitle1'>
                      Startbedingungen
                    </Typography>
                  </Divider>
                  <Grid item xs={12} display={'flex'} justifyContent={'right'}>
                    <Tooltip title='Bearbeiten Sie die Startbedingungen'>
                      <IconButton
                        onClick={() => setAddPrerequisteDeadlineOpen(true)}
                      >
                        <Edit />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <LegalRequirementDeadlineTable
                    deadlineArray={currentRequirement.DeadlineArray}
                    setDeadline={handleChangePrerequisteDeadline}
                    deleteDeadline={handleDeleteDeadline}
                  ></LegalRequirementDeadlineTable>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid item sm={12}>
          <TextModuleSelector
            key={`transaction-legalrequirementedit`}
            floatRight
            idTextModuleCategory={4}
            txt={currentRequirement.InfoText}
            setTxt={(txt: string) =>
              setCurrentRequirement({
                ...currentRequirement,
                InfoText: txt,
              })
            }
          />
          <TextField
            label='Infotext'
            value={
              currentRequirement.InfoText === null
                ? ''
                : currentRequirement.InfoText
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentRequirement({
                ...currentRequirement,
                InfoText: event.target.value === '' ? null : event.target.value,
              })
            }
            size='small'
            fullWidth
            multiline
            rows={3}
          />
        </Grid>

        <Grid item sm={4}>
          <TextField
            label='Auto. E-Mail versenden (wenn erfüllt)'
            value={currentRequirement.sendMail === true ? 'true' : 'false'}
            disabled={currentRequirement.isInterneLegalRequirement === true}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentRequirement({
                ...currentRequirement,
                sendMail: event.target.value === 'true',
              })
            }
            size='small'
            fullWidth
            select
          >
            <MenuItem value='true'>Ja</MenuItem>
            <MenuItem value='false'>Nein</MenuItem>
          </TextField>
        </Grid>

        <Grid item sm={8}>
          <TextField
            label='E-Mail Betreff'
            value={currentRequirement.EmailSubject}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentRequirement({
                ...currentRequirement,
                EmailSubject: event.target.value,
              })
            }
            size='small'
            fullWidth
          />
        </Grid>

        <CustomEditor
          txt={
            currentRequirement.EmailBody === null
              ? ''
              : currentRequirement.EmailBody
          }
          setTxt={(txt: string) =>
            setCurrentRequirement({
              ...currentRequirement,
              EmailBody: txt === '' ? null : txt,
            })
          }
          idTextModuleCategory={3}
          dictonaryIdsArray={[1, 2, 3]}
        />
        <Grid item sm={6}>
          <TextField
            label='Fehler möglich'
            value={!!currentRequirement.hasError ? 1 : 2}
            onChange={({
              target: { value },
            }: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentRequirement({
                ...currentRequirement,
                hasError: Number(value) === 1,
              })
            }
            size='small'
            fullWidth
            select
          >
            <MenuItem value={1}>Ja</MenuItem>
            <MenuItem value={2}>Nein</MenuItem>
          </TextField>
        </Grid>
        <Grid item sm={6}>
          <TextField
            label='Freitext bei Fehler erlauben'
            value={!!currentRequirement.enableFreeTextError ? 1 : 2}
            onChange={({
              target: { value },
            }: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentRequirement({
                ...currentRequirement,
                enableFreeTextError: Number(value) === 1,
              })
            }
            size='small'
            fullWidth
            select
          >
            <MenuItem value={1}>Ja</MenuItem>
            <MenuItem value={2}>Nein</MenuItem>
          </TextField>
        </Grid>

        <Grid item sm={12}>
          <TextField
            label='Fehlermeldung'
            value={currentRequirement.TextOfError}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentRequirement({
                ...currentRequirement,
                TextOfError: event.target.value,
              })
            }
            size='small'
            fullWidth
            multiline
            rows={3}
          />
        </Grid>
      </Grid>
      <AddPrerequisiteDeadline
        open={addPrerequisteDeadlineOpen}
        currentLegalRequirement={currentRequirement}
        setDeadline={handleChangePrerequisteDeadline}
        onClose={() => setAddPrerequisteDeadlineOpen(false)}
        legaltransactionId={legaltransactionId}
      ></AddPrerequisiteDeadline>

      <LegalRequirementAddCourt
        legalRequirement={currentRequirement}
        courtCourtRoleArray={courtcourtroleArray}
        open={courtcourtroleDialogOpen}
        onSave={(newLegalRequirement: ILegalRequirement) => {
          setCurrentRequirement(newLegalRequirement);
          setCourtcourtroleDialogOpen(false);
        }}
        onClose={() => setCourtcourtroleDialogOpen(false)}
      ></LegalRequirementAddCourt>
    </Box>
  );
};
